import asyncForEach from "../../../../../../Utils/Form/FormDynamic/Utils/asyncForEach";
import request from "../../../../../../Services/API/Requests";
// 🔹 Recursively extract object keys from schema
const getKeysFromSchema = (obj, path = "") => {
    let keys = [];
    for (const prop of obj.properties || []) {
        const fullPath = path ? `${path}.${prop.name}` : prop.name;
        keys.push(fullPath);
        if (prop.properties) {
            keys = keys.concat(getKeysFromSchema(prop, fullPath));
        }
    }
    return keys;
};

async function generateScriptSuggestions(screenValues) {
    let entities = screenValues.otherComponents?.filter(v => v.type === 'entity')
    let values = {};
    try {
        if(entities && entities.length) {
            await asyncForEach(entities, async (entity) => {
                try {
                    values[entity.properties.name] = await request({
                        url: "/schema/read",
                        data: {
                            id: entity.properties.name
                        }
                    })

                } catch (e) {
                    console.log(e)
                }
            })


            const allPaths = Object.keys(values).flatMap(key => getKeysFromSchema(values[key], key));
            const entityList = Object.keys(values); // Dynamically extract root entities (['user', 'role'])

            return {
                allPaths,
                entityList
            }
        }
    } catch (e) {
        console.log('err', e)
        return {
            allPaths: [],
            entityList: []
        }
    }
}




export {
    generateScriptSuggestions
}